<template>
  <div class="yyBox">
    <!-- 应用领域 -->
    <div v-for="(item, index) in imglist"
         class="fff"
         :key="index">
      <template v-if="item.hasTwo">
        <!-- 竖着两个 -->
        <div v-for="(it, inx) in item.children"
             :key="inx" class="rrr">
          <img :src="it.logo" alt="">
          <div class="ttt">
            <div>
              <p>{{isChinese ? it.context1 : it.context1En}} <i class="icon el-icon-caret-right" style="color: #EDAC1A"></i></p>
              <p>{{isChinese ? it.context2 : it.context2En}} </p>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <!-- 竖着一个 -->
        <div class="bser">
          <img :src="item.logo" alt="">
          <div class="ttt">
            <div>
              <p>{{isChinese ? item.context1 : item.context1En}} <i class="icon el-icon-caret-right" style="color: #EDAC1A"></i></p>
              <p>{{isChinese ? item.context2 : item.context2En}} </p>
            </div>
          </div>
        </div>
      </template>


    </div>

  </div>

</template>

<script>
    export default {
        name: "yylyTemp",
      data() {
          return {
            isChinese: true,
            imglist:[
              {
                hasTwo: true,
                children: [],
              },
              {},
              {
                hasTwo: true,
                children: [],
              },
            ]
          }

      },
      computed: {
        setCAE() {
          return this.$store.state.cAeSatus
        }
      },
      watch:{
        // $route( to , from ){
        //   this.isChinese = localStorage.getItem('setCEcontrol') === '1' ? true : false
        // },
        setCAE(newVal) {
          this.isChinese = newVal === 1 ? true : false
        },
      },
      created () {
          this.getImgList()
          this.isChinese = this.$store.state.cAeSatus === 1 ? true : false;
      },
      methods: {
          async getImgList () {
            let json1 = await this.$http.get("/jishi/api/publicity/info", {
              params: {
                title: '首页-应用领域-图1'
              }
            })
            let json2 = await this.$http.get("/jishi/api/publicity/info", {
              params: {
                title: '首页-应用领域-图2'
              }
            })
            let json3 = await this.$http.get("/jishi/api/publicity/info", {
              params: {
                title: '首页-应用领域-图3'
              }
            })
            let json4 = await this.$http.get("/jishi/api/publicity/info", {
              params: {
                title: '首页-应用领域-图4'
              }
            })
            let json5 = await this.$http.get("/jishi/api/publicity/info", {
              params: {
                title: '首页-应用领域-图5'
              }
            })
            console.log(json1)
            this.imglist[0].children.push(json1.data.data)
            this.imglist[0].children.push(json2.data.data)
            json3.data.data.hasTwo = false
            this.imglist[1] = json3.data.data
            this.imglist[2].children.push(json4.data.data)
            this.imglist[2].children.push(json5.data.data)
            console.log(this.imglist)
          },

      }
    }
</script>

<style scoped>
  img{
    width: 100%;
    height: 100%;
  }
  .yyBox {
    display: flex;
  }
  .fff {
    flex: 1;
    margin-left: 3px
  }
  .fff:nth-child(1){
    margin-left: 0;
  }
  .rrr {
    margin-top: 3px;
    cursor: pointer;
  }
  .rrr:nth-child(1) {
    margin-top: 0;
  }
  .ttt {
    display: none;
  }
  .ttt>div p:nth-child(1) {
    font-size: 24px;
  }
  .ttt>div p:nth-child(2) {
    font-size: 18px;
  }

@media (max-width: 768px) {
  .yyBox{
    display: block;
  }
  .fff {
    margin-left: 10px;
    margin-right: 10px;
  }
  .fff:nth-child(1){
    margin-left: 10px;
  }
  .bser{
position: relative;
  margin-top: 3px;
    cursor: pointer;
  }
}

</style>
<style lang="stylus" scoped>
  .rrr
    position relative
  .rrr:hover .ttt
    display block
    position absolute
    width 100%
    height 100%
    background rgba(0,0,0, .6)
    top 0
  .rrr:hover .ttt>div
    position absolute
    bottom 3vw
    left 3vw
    color white
  .bser
    position relative
    color red
    cursor: pointer;

  .bser:hover .ttt
    display block
    position absolute
    width 100%
    height 100%
    background rgba(0,0,0, .6)
    top 0
  .bser:hover .ttt>div
    position absolute
    bottom 1vw
    left 2vw
    color white
</style>



// WEBPACK FOOTER //
// src/components/baseTemp/yylyTemp.vue